{
  "defaultTitle": "Não foi possível fazer o check-in",
  "defaultMessage": "Por favor, confirme as informações com seu despachante ou entre em contato com o armazém",
  "backToHomescreen": "Voltar à tela inicial",
  "hideErrorLog": "OCULTAR LOG DE ERRO",
  "viewErrorLog": "VER LOG DE ERRO",
  "errorLogMessageLabel": "Mensagem:",
  "errorLogStatusLabel": "Código de status:",
  "unknown": "Desconhecido"
}
